import { LoaderCircle } from 'lucide-react';

export default function Loader({ size }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizeClass = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  }[size || 'md'];
  const className = `animate-spin text-zinc-300 dark:text-zinc-600 ${sizeClass}`;
  return (
    <div className="flex items-center justify-center p-4">
      <LoaderCircle className={className} />
    </div>
  );
}
